import { BedDouble, Building2 } from "lucide-react";
import { useState } from "react";

export const SafeImg = ({ src, alt, className = "", kind = "hotel", testid, compact = false }) => {
  const [bad, setBad] = useState(false);
  if (src && !bad) return <img src={src} alt={alt} className={className} onError={() => setBad(true)} />;
  const Icon = kind === "room" ? BedDouble : Building2;
  return (
    <div className={`${className} relative grid place-items-center overflow-hidden bg-brand-light/60`} role="img" aria-label={alt} data-testid={testid || "image-placeholder"}>
      <div className="absolute inset-0 opacity-40" style={{ backgroundImage: "radial-gradient(circle at 30% 20%, rgba(255,255,255,.9), transparent 55%)" }} />
      <span className="relative flex flex-col items-center gap-1 text-brand/60">
        <Icon className="h-1/3 max-h-10 min-h-5 w-auto" strokeWidth={1.25} />
        {!compact && <span className="hidden px-3 text-center font-serif text-xs tracking-wide sm:block">{alt}</span>}
      </span>
    </div>
  );
};
